import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
    MdDashboard,
    MdBusinessCenter,
    MdPeople,
    MdAdd,
    MdViewList,
    MdSettings,
    MdLogout,
    MdPerson,
    MdMenu,
    MdChevronLeft,
    MdTrackChanges,
    MdClose,
    MdKeyboardArrowRight,
} from 'react-icons/md';
import Cookies from 'js-cookie';
import { IoMdArrowDropdown } from 'react-icons/io';
import './Sidebar.css';

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [openDropdown, setOpenDropdown] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth <= 768) {
                setIsOpen(false);
            } else {
                setIsOpen(true);
            }
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const body = document.body;

        body.classList.toggle('sidebar-mobile', isMobile);
        body.classList.toggle('sidebar-open', !isMobile && isOpen);
        body.classList.toggle('sidebar-closed', !isMobile && !isOpen);

        return () => {
            body.classList.remove('sidebar-mobile', 'sidebar-open', 'sidebar-closed');
        };
    }, [isMobile, isOpen]);

    useEffect(() => {
        const handleToggleSidebar = () => {
            if (!isMobile) {
                setIsOpen(prev => !prev);
            }
        };

        window.addEventListener('toggle-sidebar', handleToggleSidebar);
        return () => window.removeEventListener('toggle-sidebar', handleToggleSidebar);
    }, [isMobile]);

    const handleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? '' : menu);
    };

    const handleLogout = () => {
        Cookies.remove('token');
        navigate('/login');
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const MenuItem = ({ icon: Icon, text, path, onClick, hasDropdown = false }) => (
        <div
            className={`menu-item ${isActive(path) ? 'active' : ''}`}
            onClick={onClick}
        >
            <div className="menu-item-content">
                <Icon className="menu-icon" />
                <span className="menu-text">{text}</span>
                {hasDropdown && (
                    <IoMdArrowDropdown
                        className={`dropdown-arrow ${openDropdown === text ? 'open' : ''}`}
                    />
                )}
            </div>
        </div>
    );

    const DropdownItem = ({ icon: Icon, text, path }) => (
        <Link to={path} className={`dropdown-item ${isActive(path) ? 'active' : ''}`}>
            <Icon className="dropdown-icon" />
            <span style={{ marginLeft: '10px' }} className="dropdown-text">{text}</span>
        </Link>
    );

    // Mobile menu trigger
    const MobileMenuTrigger = () => (
        <button
            className="mobile-menu-trigger"
            onClick={toggleSidebar}
            aria-label="Toggle menu"
        >
            <MdMenu />
        </button>
    );



    return (
        <>
            {isMobile && <MobileMenuTrigger />}

            <div className={`sidebar ${isOpen ? 'open' : 'closed'} ${isMobile ? 'mobile' : ''}`}>
                <div className="sidebar-header">
                    <div className="logo-container">
                        <img src="/celebration logo.png" alt="PMS" className="logo-img" />
                    </div>
                </div>

                <div className="sidebar-content">
                    <div className="menu-section">
                        <Link to="/hod/dashboard">
                            <MenuItem
                                icon={MdDashboard}
                                text="Dashboard"
                                path="/hod/dashboard"
                            />
                        </Link>
                    </div>

                    <div className="menu-section">
                        <MenuItem
                            icon={MdPeople}
                            text="Employees"
                            onClick={() => handleDropdown('Employees')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'Employees' ? 'show' : ''}`}>
                            <DropdownItem
                                icon={MdAdd}
                                text="Add Employee"
                                path="/hod/add-employee"
                            />
                            <DropdownItem
                                icon={MdViewList}
                                text="View Employees"
                                path="/hod/employees"
                            />

                            <DropdownItem
                                icon={MdViewList}
                                text="Improvement Plans"
                                path="/hod/employees-improvement-plans"
                            />
                        </div>
                    </div>


                    <div className="menu-section">
                        <MenuItem
                            icon={MdBusinessCenter}
                            text="Key  Result Areas"
                            onClick={() => handleDropdown('KRA')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'KRA' ? 'show' : ''}`}>

                            <DropdownItem
                                icon={MdAdd}
                                text="Add KRA"
                                path="/hod/create-key-result-area"
                            />
                        </div>
                        <div className={`dropdown ${openDropdown === 'KRA' ? 'show' : ''}`}>

                            <DropdownItem
                                icon={MdViewList}
                                text="View KRAs"
                                path="/hod/key-result-areas"
                            />
                        </div>
                    </div>

                    <div className="menu-section">
                        <MenuItem
                            icon={MdTrackChanges}
                            text="My KPIs"
                            onClick={() => handleDropdown('MyGoals')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'MyGoals' ? 'show' : ''}`}>

                            <DropdownItem
                                icon={MdAdd}
                                text="Create KPI"
                                path="/hod/create-goal"
                            />
                        </div>
                        <div className={`dropdown ${openDropdown === 'MyGoals' ? 'show' : ''}`}>

                            <DropdownItem
                                icon={MdViewList}
                                text="View KPIs"
                                path="/hod/goals"
                            />
                        </div>
                    </div>

                    <div className="menu-section">
                        <Link to="/hod/my-goals-reviews">
                            <MenuItem
                                icon={MdViewList}
                                text="My KPIs Reviews"
                                path="/hod/my-goals-reviews"
                            />
                        </Link>
                    </div>

                    <div className="menu-section">
                        <MenuItem
                            icon={MdTrackChanges}
                            text="Improvement Plans"
                            onClick={() => handleDropdown('MyIPs')}
                            hasDropdown
                        />
                        <div className={`dropdown ${openDropdown === 'MyIPs' ? 'show' : ''}`}>

                            <DropdownItem
                                icon={MdAdd}
                                text="Create IP"
                                path="/hod/create-improvement-plan"
                            />
                        </div>
                        <div className={`dropdown ${openDropdown === 'MyIPs' ? 'show' : ''}`}>

                            <DropdownItem
                                icon={MdViewList}
                                text="View IPs"
                                path="/hod/improvement-plans"
                            />
                        </div>
                    </div>

                    <div className="menu-divider"></div>

                    <div className="menu-section secondary-menu">
                        <Link to="/hod/profile">
                            <MenuItem
                                icon={MdPerson}
                                text="Profile"
                                path="/hod/profile"
                            />
                        </Link>

                        <Link to="/hod/change-password">
                            <MenuItem
                                icon={MdSettings}
                                text="Change Password"
                                path="/hod/change-password"
                            />
                        </Link>
                    </div>

                    <div className="menu-item logout" onClick={handleLogout}>
                        <div className="menu-item-content">
                            <MdLogout className="menu-icon" />
                            <span className="menu-text">Logout</span>
                        </div>
                    </div>
                </div>
            </div>

            {isMobile && isOpen && (
                <div className="sidebar-overlay" onClick={toggleSidebar}></div>
            )}
        </>
    );
};

export default Sidebar;
